import axios from "axios";
import { Constants } from "../utils/constants";
import { CookieService } from "./cookie.service";
import { Utils } from "../utils/utils";

export const getUserProfile = () => {
  return axios
    .get(Constants.GetOmniProfileUrl, {
      headers: {
        ansid: CookieService.getCookie("ANsid"),
        clientid: Utils.getRouteParam("clientid"),
      },
    })
    .then((response) => response);
};

export const getTaxonomy = (taxonomyType) => {
  return axios
    .get(
      Constants.taxonomyUrl + "/" + Utils.getRouteParam("clientid") + "/schema",
      {
        params: { type: taxonomyType },
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid"),
        },
      },
    )
    .then(
      (response) => response && response.data,
      (error) => Promise.reject(error),
    );
};

export const getClientCodes = () => {
  return axios
    .get(
      Constants.ClientDataUrl +
        "/" +
        Utils.getRouteParam("clientid") +
        "/clientcodes",
      {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid"),
        },
      },
    )
    .then((response) => response);
};

export const getMediaOpsClientProfile = () => {
  return axios
    .get(
      Constants.ClientDataUrl +
        "/" +
        Utils.getRouteParam("clientid") +
        "/mediaopsclientprofile",
      {
        headers: { ansid: CookieService.getCookie("ANsid") },
      },
    )
    .then((response) => response?.data)
    .catch((error) => Promise.reject(error));
};

export const getOrphanedDeliveredData = (params = {}, hasNext) => {
  let url =
    Constants.ClientDataUrl +
    "/" +
    Utils.getRouteParam("clientid") +
    "/" +
    "taxonomy_values";
  if (hasNext) {
    url = hasNext;
    params = {};
  }
  return axios
    .get(url, {
      headers: {
        ansid: CookieService.getCookie("ANsid"),
        clientid: Utils.getRouteParam("clientid"),
      },
      params: { ...params },
    })
    .then((response) => response);
};

export const mapOrphanedDeliveredData = (payload, params) => {
  return axios
    .put(
      Constants.ClientDataUrl +
        "/" +
        Utils.getRouteParam("clientid") +
        "/" +
        "taxonomy_values",
      payload,
      {
        headers: {
          ansid: CookieService.getCookie("ANsid"),
          clientid: Utils.getRouteParam("clientid"),
        },
        params,
      },
    )
    .then((response) => response);
};

/**
 * Global search across campaigns, placements, and creatives.
 * @function globalSearch
 * @param {string} searchQuery - The search query string
 * @returns {Promise<Object>} A promise that resolves to an object containing:
 *                            - array of results for all three entities: campaigns, placements, creatives
 * @example
 * MediaOpsService.globalSearch('campaign name')
 *   .then(results => {
 *     console.log(results);
 *   });
 */
export const globalSearch = async (searchQuery) => {
  const url = `${Constants.ClientConfigurationUrl}`;

  try {
    const response = await axios.get(url, {
      params: {
        "partition-key": "client_id",
        "partition-value": Utils.getRouteParam("clientid"),
        "filter-key1": "entity_key_words",
        "filter-value1": searchQuery,
      },
      headers: {
        ansid: CookieService.getCookie("ANsid"),
        clientid: Utils.getRouteParam("clientid"),
      },
    });

    return response?.data || [];
  } catch (error) {
    console.error("Global search API error:", error);
    // Return empty results on error
    return [];
  }
};
